import _styled from "styled-components";
var _excluded = ["style", "value", "onCreate"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { LinkButton } from '@adsk/alloy-button';
import { useLocale } from '@adsk/alloy-helpers';
import theme from '@adsk/alloy-theme';

var CreateNewMenuItem = function CreateNewMenuItem(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      value = _ref.value,
      onCreate = _ref.onCreate,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useLocale = useLocale(function (_ref2) {
    var locale = _ref2.locale;
    return require("../../i18n/".concat(locale, ".json"));
  }),
      T = _useLocale.T;

  return /*#__PURE__*/React.createElement(LinkButton, _extends({
    style: _objectSpread({
      height: 40,
      width: '100%',
      padding: '8px 16px 8px',
      justifyContent: 'flex-start'
    }, style),
    onClick: function onClick(e) {
      onCreate === null || onCreate === void 0 ? void 0 : onCreate(value, e);
    }
  }, props), /*#__PURE__*/React.createElement(_StyledSpan, {
    $_css: [theme.typography.ellipsis]
  }, T.translate('CREATE_OPTION', {
    label: value
  })));
};

CreateNewMenuItem.propTypes = _objectSpread(_objectSpread({}, LinkButton.propTypes), {}, {
  value: PropTypes.string.isRequired,
  onCreate: PropTypes.func
});
export default CreateNewMenuItem;

var _StyledSpan = _styled("span").withConfig({
  displayName: "CreateNewMenuItem___StyledSpan",
  componentId: "sc-5r3lxu-0"
})(["", ""], function (p) {
  return p.$_css;
});
//# sourceMappingURL=CreateNewMenuItem.js.map